import BulkEditController from './bulk-edit/bulk-edit.controller';

const bulkEditTemplate = require('./bulk-edit/bulk-edit.html');

export default class ThingsToolboxController {
    /**
     * @param ThingsService
     * @param EventEmitter
     * @param DialogService
     * @param $state
     * @ngInject
     */
    constructor(ThingsService, EventEmitter, DialogService, $state) {
        this.ThingsService = ThingsService;
        this.eventEmitter = EventEmitter;
        this.DialogService = DialogService;
        this.$state = $state;
    }

    $onInit() {
        this.showFilterParams = false;
        this.isSearchFocused = false;
        this.iconSize = 'm';
        this.things = this.ThingsService.getAllThings();
    }

    searchByType(type) {
        this.predefinedQuery = `type.id:${type}`;
        this.passSearchResult({
            query: this.predefinedQuery
        });
        this.closeFilterParams();
    }

    searchStarred() {
        this.predefinedQuery = 'starred:true';
        this.passSearchResult({
            query: this.predefinedQuery
        });
        this.closeFilterParams();
    }

    toggleFilterParams() {
        this.showFilterParams = !this.showFilterParams;
    }

    clearSearch() {
        this.onEmptySearch();
    }

    closeFilterParams() {
        this.showFilterParams = false;
    }

    isShowFilterParams() {
        return this.showFilterParams;
    }

    onSearchFocusChange($event) {
        if (this.showFilterParams) {
            this.showFilterParams = !$event.isFocused;
        }
        this.isSearchFocused = $event.isFocused;
    }

    onClickAdvancedSearch() {
        this.toggleFilterParams();

        this.onShowAdvancedSearch();
    }

    showGraphs() {
        this.$state.go('main.sensors.graphs');
    }

    openBulkEditPopup(ev) {
        this.DialogService.show({
            controller: BulkEditController,
            controllerAs: '$ctrl',
            template: bulkEditTemplate,
            parent: document.body,
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: true,
            locals: {
                selectedThings: this.selectedThings
            }
        });
    }

    passSearchResult({ query }) {
        this.onSearchResult(
            this.eventEmitter({ query })
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/things-toolbox/things-toolbox.controller.js